@import './../style.module';

@modal-footer-height: 50px;

.modal-footer {
  padding-left: @modal-padding;
  padding-right: @modal-padding;
  @height: @modal-footer-height;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.action-button-group {
  button + button {
    margin-left: 10px;
  }
}
